
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import EnhancedBuyerRegistrationForm from "@/components/buyer/registration/EnhancedBuyerRegistrationForm";

const BuyerRegisterPage = () => {
  return (
    <Card className="bg-gray-800 border-gray-700">
      <CardHeader className="text-center">
        <CardTitle className="text-2xl text-[#ffd700]">Create Your Buyer Account</CardTitle>
        <CardDescription className="text-gray-300">
          Create your free account and find your next investment property
        </CardDescription>
      </CardHeader>
      <CardContent>
        <EnhancedBuyerRegistrationForm />
      </CardContent>
    </Card>
  );
};

export default BuyerRegisterPage;
